export enum FullscreenLoaderActionTypes {
  SHOW_LOADING = "SHOW_LOADING",
  HIDE_LOADING = "HIDE_LOADING"
}

export interface IShowLoading {
  type: FullscreenLoaderActionTypes.SHOW_LOADING;
  payload?: string;
}

export interface IHideLoading {
  type: FullscreenLoaderActionTypes.HIDE_LOADING;
}

export const showLoading = (loadingText?: string): IShowLoading => ({
  type: FullscreenLoaderActionTypes.SHOW_LOADING,
  payload: loadingText
});

export const hideLoading = (): IHideLoading => ({
  type: FullscreenLoaderActionTypes.HIDE_LOADING
});

export type FullscreenLoaderActions = IShowLoading | IHideLoading;
